// extracted by mini-css-extract-plugin
module.exports = {"container":"InvoicesAdd_container__39StX","addinvoice":"InvoicesAdd_addinvoice__13-nR"};